/* home-decision-hero.js — full-screen popup: open/close, scroll lock, ESC, focus return. */
(function () {
  if (window.__dhBound) return;
  window.__dhBound = true;

  var lastFocused = null;

  function openPopup(popup) {
    if (!popup) return;
    lastFocused = document.activeElement;
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var closeBtn = popup.querySelector('[data-dh-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup(popup) {
    if (!popup) return;
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(function () { popup.hidden = true; }, 240);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dh-open]');
    if (opener) {
      e.preventDefault();
      openPopup(document.getElementById(opener.getAttribute('data-dh-open')));
      return;
    }
    var closer = e.target.closest('[data-dh-close]');
    if (closer) {
      closePopup(closer.closest('[data-dh-popup]'));
      return;
    }
    // click on the overlay (outside the sheet) closes
    var popup = e.target.closest('[data-dh-popup]');
    if (popup && !e.target.closest('[data-dh-sheet]')) closePopup(popup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-dh-popup].is-open');
    if (open) closePopup(open);
  });

  // simple focus trap while open
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var popup = document.querySelector('[data-dh-popup].is-open');
    if (!popup) return;
    var f = popup.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();